import React, { FC } from 'react';
import { useRole } from 'common/hooks/useRole';

export const SuperAdminGuard: FC = (props) => {
  const { isSuperAdmin } = useRole();
  return isSuperAdmin ? <>{props.children}</> : null;
};
